import { useQuery } from "react-query";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import axios from "axios";


const getQCPlatelist = async () => {

    const headerConfig = setHeaders();

    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qc/list_plates`, {
        headers: headerConfig
    });

    return data;
}

export const useFetchQCPlatelist = () => {
    return useQuery("QCPlatelist", getQCPlatelist);
}